import MyWorkAppProto from "../common/app-proto";
import MyWorkView from "../common/model/my-work-view";
import {myWorkViewDictionary} from "../common/@const";


export default function openMyWorkView(app: MyWorkAppProto, view: MyWorkView) {

    const viewName = myWorkViewDictionary[view.type]

    if (viewName === view.id) {

        let url = `my-work/${viewName}`

        gd.goTo(url);
        app.updateMainNavigation(url)
    } else {

        let url = `my-work/${viewName}/${view.id}`

        gd.goTo(url);
        app.updateMainNavigation(url)
    }
}
